var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,13 C9.49264069,13 10.5,14.0073593 10.5,15.25 C10.5,16.4926407 9.49264069,17.5 8.25,17.5 C7.00735931,17.5 6,16.4926407 6,15.25 C6,14.0073593 7.00735931,13 8.25,13 Z M15,13 C16.2426407,13 17.25,14.0073593 17.25,15.25 C17.25,16.4926407 16.2426407,17.5 15,17.5 C13.7573593,17.5 12.75,16.4926407 12.75,15.25 C12.75,14.0073593 13.7573593,13 15,13 Z M21.75,13 C22.9926407,13 24,14.0073593 24,15.25 C24,16.4926407 22.9926407,17.5 21.75,17.5 C20.5073593,17.5 19.5,16.4926407 19.5,15.25 C19.5,14.0073593 20.5073593,13 21.75,13 Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ac3095fe.svg";
export { ForwardRef as ReactComponent };